<template>
  <BaseModal :isShow="isShow" @close="closeModal">
    <div class="flex flex-col p-6 text-center h-[80vh] w-full">
      <div class="my-1">
        <IconClose class="cursor-pointer" @click="closeModal" />
      </div>
      <div class="w-full flex flex-col justify-center items-center">
        <div class="text-base laptop:text-3xl font-bold">
          {{
            id == "round_price"
              ? "مقایسه ویژگی‌های دفترکار مجازی"
              : computedPackageData.title
          }}
        </div>
        <!-- for desktop -->
        <table class="just-desktop flex-grow my-6">
          <thead class="font-bold border [&>*]:p-3 w-full">
            <th class="">{{ computedPackageData.subTitle }}</th>
            <th v-if="computedPackageData.packagenames.boronz">
              {{ computedPackageData.packagenames.boronz }}
            </th>
            <th class="">
              {{ computedPackageData.packagenames.noghre }}
            </th>
            <th class="">
              {{ computedPackageData.packagenames.talaei }}
            </th>
            <th class="">
              {{ computedPackageData.packagenames.opal }}
            </th>
          </thead>
          <tbody class="w-full">
            <template v-if="computedPackageData.listPack">
              <tr
                v-for="item in computedPackageData.listPack"
                :key="item.id"
                class="[&>*]:p-3 text-[#283175] odd:text-[#6377B9] odd:bg-[#F6F7FA] odd:opacity-50"
              >
                <td>{{ item.title }}</td>
                <td v-if="computedPackageData.packagenames.boronz">
                  {{ item.boronz }}
                </td>
                <td>{{ item.noghre }}</td>
                <td>{{ item.talaei }}</td>
                <td>{{ item.opal }}</td>
              </tr>
            </template>
            <template v-if="computedPackageData.options">
              <tr
                v-for="item in computedPackageData.options"
                :key="item.id"
                class="[&>*]:p-3 fill-blue-500 text-[#283175] odd:bg-blue-100 odd:opacity-80 odd:text-[#6377B9]"
              >
                <td>{{ item.title }}</td>
                <td v-if="computedPackageData.packagenames.boronz">
                  <template v-if="item.packages.boronz">
                    <IconTik class="mx-auto" />
                  </template>
                  <template v-else>
                    <IconLine class="mx-auto" />
                  </template>
                </td>
                <td>
                  <template v-if="item.packages.noghre">
                    <IconTik class="mx-auto" />
                  </template>
                  <template v-else>
                    <IconLine class="mx-auto" />
                  </template>
                </td>
                <td>
                  <template v-if="item.packages.talaei">
                    <IconTik class="mx-auto" />
                  </template>
                  <template v-else>
                    <IconLine class="mx-auto" />
                  </template>
                </td>
                <td>
                  <template v-if="item.packages.opal">
                    <IconTik class="mx-auto" />
                  </template>
                  <template v-else>
                    <IconLine class="mx-auto" />
                  </template>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <!-- for mobile -->
        <div class="just-mobile">
          <div class="text-sm py-3 text-right border-b-2">
            {{ computedPackageData.subTitle }}
          </div>
          <div v-if="computedPackageData.listPack" class="">
            <div
              v-for="pack in computedPackageData.listPack"
              :key="pack.id"
              class="py-3 text-right border-b-2"
            >
              <span class="text-sm font-bold text-blue-700">
                {{ pack.title }}
              </span>

              <div class="w-full">
                <div class="w-full flex items-center justify-around my-2">
                  <span
                    v-for="name in computedPackageData.packagenames"
                    :key="name"
                    class="text-[10px] font-bold"
                  >
                    {{ getShortName(name) }}
                  </span>
                </div>
                <div
                  class="w-full flex items-center justify-around font-bold text-lg"
                >
                  <span>{{ pack.boronz }}</span>
                  <span>{{ pack.noghre }}</span>
                  <span>{{ pack.talaei }}</span>
                  <span>{{ pack.opal }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- ************* -->
          <div v-if="computedPackageData.options" class="">
            <div
              v-for="pack in computedPackageData.options"
              :key="pack.id"
              class="py-3 text-right border-b-2"
            >
              <span class="text-sm font-bold text-blue-700">
                {{ pack.mobile_title ? pack.mobile_title : pack.title }}
              </span>
              <div class="flex items-center justify-around w-full my-2">
                <span
                  v-for="name in computedPackageData.packagenames"
                  :key="name"
                  class="text-[10px] font-bold"
                >
                  {{ getShortName(name) }}
                </span>
              </div>
              <div
                class="flex items-center justify-around w-full text-blue-500"
              >
                <span>
                  <template v-if="pack.packages.boronz">
                    <IconTik />
                  </template>
                  <template v-else>
                    <IconLine />
                  </template>
                </span>
                <span>
                  <template v-if="pack.packages.noghre">
                    <IconTik />
                  </template>
                  <template v-else>
                    <IconLine />
                  </template>
                </span>
                <span>
                  <template v-if="pack.packages.talaei">
                    <IconTik />
                  </template>
                  <template v-else>
                    <IconLine />
                  </template>
                </span>
                <span>
                  <template v-if="pack.packages.opal">
                    <IconTik />
                  </template>
                  <template v-else>
                    <IconLine />
                  </template>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
const props = defineProps({
  isShow: Boolean,
  data: {
    type: Object,
    required: false,
  },
  title: String,
  id: String,
});

const emit = defineEmits(["close"]);

const closeModal = () => {
  emit("close");
};

const computedPackageData = computed(() => {
  if (props.data) {
    return props.data;
  } else {
    return dataPackage;
  }
});

const getShortName = (name) => {
  let nameArray = name.split(" ");
  nameArray.splice(0, 1);
  return nameArray.join(" ");
};

const dataPackage = {
  id: 1,
  title: "مقایسه ویژگی‌های بسته های مرکز تلفن ",
  subTitle: "ویژگی های اصلی",
  packagenames: {
    boronz: "بسته برنزی",
    noghre: "بسته نقره ای",
    talaei: "بسته طلایی",
    opal: "بسته اپال",
  },
  listPack: [
    {
      id: 1,
      title: " فضای ابری (گیگ)",
      boronz: "1",
      noghre: "2",
      talaei: "5",
      opal: "10",
    },
    {
      id: 2,
      title: "تعداد کاربر",
      boronz: "5",
      noghre: "10",
      talaei: "20",
      opal: "30",
    },
  ],
  options: [
    {
      id: 3,
      title: "چت سازمانی (ایجاد گروه، پیام یک به یک)",
      mobile_title: "چت سازمانی",
      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 4,
      title: "امکان ساخت کانال های اطلاع رسانی",
      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 5,
      title: "ویدئو کنفرانس",
      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 6,
      title: "اشتراک گذاری فایل",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 7,
      title: "سرویس دفترچه تلفن",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    // {
    //   id: 8,
    //   title: "قابلیت مسدود کردن مخاطبین",

    //   packages: {
    //     boronz: true,
    //     noghre: true,
    //     talaei: true,
    //     opal: true,
    //   },
    // },
    {
      id: 9,
      title: "پشتیبانی از تاریخ شمسی/میلادی",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 10,
      title: "پشتیبانی از زبان فارسی/ انگلیسی",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 11,
      title: " تماس صوتی و تصویری یک به یک",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 12,
      title: " دریافت نوتیفیکیشن تماس ",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 13,
      title: "هلد و ترنسفر",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 14,
      title: "امکان مدیریت تماس های همزمان(پشت خطی)",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 15,
      title: "دریافت لیست های وارده و صادره در تب تماس",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 16,
      title: "گزارش تماس‌های بی پاسخ ",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 17,
      title: "دریافت میس کال در حالت آنلاین و آفلاین",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 18,
      title: "کیف پول و امکان شارژ بر روی اپلیکیشن ",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 19,
      title: "مالتی دیوایس (چند دستگاهی)",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 20,
      title: "عدم از دست رفتن سابقه پیام‌ها در صورت نصب مجدد اپلیکیشن",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 21,
      title: "امکان سرچ هوشمند",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 22,
      title: "استیکر",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 23,
      title: "بارگذاری صوت",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 24,
      title: "مدیریت صف",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 25,
      title: "منوی آی وی آر",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 44,
      title: "تماس مجدد با آخرین اپراتور",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 26,
      title: "هدایت تماس‌ها",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 27,
      title: "ضبط مکالمات",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 28,
      title: "گزارش وضعیت اتصال تماس‌ها",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 29,
      title: "گزارش تماس‌های پاسخ داده شده",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 30,
      title: "گزارش تماس‌های بی پاسخ ",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 31,
      title: "گزارش فعالیت اپراتورها",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 32,
      title: "لاگ تماس‌های ضبط شده",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 33,
      title: "تماس امن",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 34,
      title: "پشتیبانی 24/7",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 35,
      title: "امکان تنظیم ساعت کاری",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 37,
      title: "پیامگیر صوتی",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 43,
      title: "لیست سیاه و سفید",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 36,
      title: "تیکتینگ",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 38,
      title: "نظرسنجی",

      packages: {
        boronz: false,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 39,
      title: "قابلیت استفاده از آی پی فون",

      packages: {
        boronz: false,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 40,
      title: "گزارش پیشرفته",

      packages: {
        boronz: false,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 42,
      title: "گزارش پراکندگی",

      packages: {
        boronz: false,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 41,
      title: "تعیین سطوح دسترسی",

      packages: {
        boronz: false,
        noghre: false,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 42,
      title: "مانیتورینگ زنده",

      packages: {
        boronz: false,
        noghre: false,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 44,
      title: "کنترل زنده تماس‌ها",

      packages: {
        boronz: false,
        noghre: false,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 45,
      title: "نجوا",

      packages: {
        boronz: false,
        noghre: false,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 46,
      title: "ورود به مکالمه زنده",

      packages: {
        boronz: false,
        noghre: false,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 40,
      title: "والبورد",

      packages: {
        boronz: false,
        noghre: false,
        talaei: false,
        opal: true,
      },
    },
    {
      id: 40,
      title: "سرویس اعلان",

      packages: {
        boronz: false,
        noghre: false,
        talaei: false,
        opal: true,
      },
    },
  ],
};
</script>
